import styles from './ChatScreen.module.css'

interface ChatHeaderProps {
  title: string
  memberCount?: number
}

export default function ChatHeader({ title, memberCount }: ChatHeaderProps) {
  const memberLabel =
    memberCount === undefined
      ? null
      : memberCount === 1
        ? '1 member'
        : `${memberCount} members`

  return (
    <header className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      {memberLabel && <p className={styles.memberCount}>{memberLabel}</p>}
    </header>
  )
}
